import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import "./import-widget.scss";
import { useSelector } from "react-redux";
import { TCategory, TWidget } from "./constants";
import { Http } from "../../../../helpers/axois";

import { ReactComponent as Import } from "../../../../assets/svg/import.svg";
import ImportInstalledWidget from "./ImportInstalledWidget";
import Categories from "./Categories";
import { useToast } from "../../../../helpers/commonFunction";
import { AppState } from "../../../../stateManager/store";



const allCatagories: TCategory[] = ["Widgets", "Installed Widgets"]


interface IProps {
  appId: string;
  formId: string;
}

const ImportWidget: React.FC<IProps> = (props): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(false);
  const [widgets, setWidgets] = useState<TWidget[]>([])
  const [activeTab, setActiveTab] = useState<TCategory>('Widgets');
  const { ErrorToast } = useToast()
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const getFilteredWidgets = () => {
    if (activeTab === "Installed Widgets") {
      return widgets.filter(({ is_installed }) => is_installed);
    }
    return widgets;
  };

  const onClick = (value: TCategory) => {
    setActiveTab(value);
  };

  const showModal = (): void => {
    setVisible(true);
  };

  const handleCancel = (): void => {
    setVisible(false);
  };

  const handleOk = (): void => {
    setVisible(false);
  };

  useEffect(() => {
    try{
     if ((!orgPermissions?.includes("app.Import") || !orgPermissions.includes('org.View')) &&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching widgets")
      return
    }  
    Http
    .get(`/orgs/${orgId}/store/products?type=widget`).subscribe((res: any)=>{
      if(res){
        setWidgets(res);
      }
    })
    } catch (err) {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching widgets")
      }
    }
  },[orgId])

  if (!widgets) {
    return (
      <div>Loading...!</div>
    )
  }
  return (
    <div className="widget-import">
      <Import data-test-id="show_modal" height="25px" width="25px" onClick={showModal} />
      {visible && <Modal
        className="override-modal"
        width="1115px"
        title="IMPORT WIDGET"
        maskClosable={false}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="widget-import-header">
          <Categories
            data-test-id="categories"
            onClick={onClick}
            activeTab={activeTab}
            allCatagories={allCatagories}
          />
        </div>
        <ImportInstalledWidget
          activeTab={activeTab}
          widgets={getFilteredWidgets()}
          onInstall={() => setVisible(false)}
          appId={props.appId}
          formId={props.formId}
        />
      </Modal>}
    </div>
  );
};

export default ImportWidget;
